import React, { useEffect, useState } from 'react'
import { Modal, Table, Form } from 'react-bootstrap';
import CustomButton from '../../../components/CustomButton';
import { errorSwal, successSwal } from '../../../helper/sweetalert';
import { useLazyQuery, useMutation } from '@apollo/client';
import { ADD_USER_TYPE, EDIT_USER_TYPE, GET_USER_TYPE } from '../../../apollo/userType/mutation';
import _ from 'lodash';


export default function UserTypeManage() {
  // Get User Type Data
  const [data, setData] = useState([]);
  const [userTypeData, {data: getUserTypeData, loading: getUserTypeLoading }] 
  = useLazyQuery(GET_USER_TYPE, { fetchPolicy: 'cache-and-network' });
  useEffect(() => {
    userTypeData();
  }, []);

  useEffect(() =>  {
    if(!_.isEmpty(getUserTypeData?.getUserTypes)) {
      setData(getUserTypeData?.getUserTypes);
    }
  }, [getUserTypeData]);

  //! ເພີ່ມ
  const [addUserType, { loading: addUserLoading }] = useMutation(ADD_USER_TYPE);
  const [addModal, setAddModal] = useState(false);
  const AddUserType = () => {
    const [name, setName] = useState('');
    const closeAddModal = () => {setAddModal(false); setName('')};
    
    const handleNameChange = (e) => {
      setName(e?.target?.value);
    };
    const handleAddSubmit = async (e) => {
      try { 
        e.preventDefault(); // Prevents the default form submission behavior
        const addOk = await addUserType({ variables: { data: {name} } });
        if(addOk?.data?.addUserType !== "OK") throw addOk?.errors;

        closeAddModal(); // Close the modal after submission
        successSwal('ເພີ່ມປະເພດຜູ້ໃຊ້ສຳເລັດແລ້ວ');
        await userTypeData();
      } catch (error) {
        closeAddModal();
        errorSwal(error.message ===  "DUPLICATE_DATA" ? "ຂໍ້ມູນຊ້ຳກັນ ລອງໃຫມ່ພາຍຫລັງ" : 'ເພີ່ມປະເພດຜູ້ໃຊ້ບໍ່ສຳເລັດ');
        console.log('Error adding user type:', error.message);
      }
    };

    return (
      addUserLoading ? <>ເພີ່ມປະເພດຜູ້ໃຊ້...</> :
      <>
        <Modal centered show={addModal} onHide={() => setAddModal(false)}>
          <Modal.Header closeButton style={{ backgroundColor: '#6EC207', color: "white" }}>
            <Modal.Title>ເພີ່ມປະເພດລູກຄ້າ</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
            <div className="form-group">
              <label for="userCategoryName">ຊື່</label>
              <Form.Control value={name} type="text"
                placeholder="ໃສ່ຊື່" 
                onChange={(e) => handleNameChange(e)} />
              <small id="nameHelp" className="form-text text-muted">ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຖືກຕ້ອງ</small>
            </div>
            <br />
            <br />
            <br />
            <br />
            <div className="form-buttons">
              <button type="button" className="btn btn-danger"
                onClick={() => closeAddModal()}
              > ຍົກເລີກ </button>
              <button type="submit" className="btn btn-primary" style={{marginLeft: "10px"}}
                onClick={(e) => handleAddSubmit(e)} 
              >
                ບັນທຶກ
              </button>
            </div>
          </form>
          </Modal.Body>
        </Modal>
      </>
    );
  };
  
  //! ປີດ
  const [editUserType, { loading: editUserLoading }] = useMutation(EDIT_USER_TYPE);
  const handleCloseSubmit = async (item) => {
    try { 
      const closeOk = await editUserType({ variables: { where: {id: item?.id}, 
        data: {name: item?.name, isOpen: false} }
      });
      if(closeOk?.data?.editUserType !== "OK") throw closeOk?.errors;

      successSwal('ປີດປະເພດຜູ້ໃຊ້ສຳເລັດແລ້ວ');
      await userTypeData();
    } catch (error) {
      errorSwal('ປີດປະເພດຜູ້ໃຊ້ບໍ່ສຳເລັດ');
      console.log('Error closing user type:', error.message);
    }
  };

  //! ເປີດ
  const handleOpenSubmit = async (item) => {
    try { 
      const openOk = await editUserType({ variables: { where: {id: item?.id},
        data: {name: item?.name, isOpen: true} }
      });
      if(openOk?.data?.editUserType !== "OK") throw openOk?.errors;
      
      successSwal('ເປີດປະເພດຜູ້ໃຊ້ສຳເລັດແລ້ວ');
      await userTypeData();
    } catch (error) {
      errorSwal('ເປີດປະເພດຜູ້ໃຊ້ບໍ່ສຳເລັດ');
      console.log('Error opening user type:', error.message);
    }
  };
  
  //! ແກ້ໄຂ້
  const [editModal, setEditModal] = useState({modal: false, item: null});
  const EditUserType = () => {
    const { modal, item } = editModal;
    const [editName, setEditName] = useState(item?.name || '');
    const closeEditModal = () => setEditModal({ modal: false, item: null });

    const handleNameEdit = (e) => {
      const { value } = e.target;
      setEditName(value);
    };
    
    const handleEditSubmit = async (e) => {
      e.preventDefault(); // Prevents default form submission behavior
      if (!editName.trim()) {
        errorSwal('ກະລຸນາກ໊ອກຊື່ໃຫ້ຖືກຕ້ອງ');
        return;
      };

      try { 
        const editOk = await editUserType({ variables: 
          { 
            where: {id: item?.id},
            data: {name: editName} 
          }
        });
        if(editOk?.data?.editUserType !== "OK") throw editOk?.errors;
  
        successSwal('ແກ້ໄຊ້ປະເພດຜູ້ໃຊ້ສຳເລັດແລ້ວ');
        closeEditModal();
        await userTypeData();
      } catch (error) {
        errorSwal('ແກ້ໄຊ້ປະເພດຜູ້ໃຊ້ບໍ່ສຳເລັດ');
        console.log('Error editing user type:', error.message);
      }
    };
  
    return (
      editUserLoading ? <p>ແກ້ໄຂ້ປະເພດຜູ້ໃຊ້...</p> :
      <Modal centered show={modal} onHide={closeEditModal}>
        <Modal.Header
          closeButton
          style={{ backgroundColor: '#3C169B', color: 'white' }}
        >
          <Modal.Title>ແກ້ໄຂ້ປະເພດລູກຄ້າ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
            <div className="form-group">
              <label htmlFor="name">ຊື່</label>
              <Form.Control
                id="name"
                value={editName}
                type="text"
                placeholder="ໃສ່ຊື່"
                onChange={handleNameEdit}
                required
              />
              <small id="nameHelp" className="form-text text-muted">
                ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຖືກຕ້ອງ
              </small>
            </div>
            <div className="form-buttons mt-4">
              <button
                type="button"
                className="btn btn-danger"
                onClick={closeEditModal}
              >
                ຍົກເລີກ
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                style={{ marginLeft: '10px' }}
              >
                ບັນທຶກ
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  };

 // Define NewButton Component
  const NewButton = ({ title, color, border, onClick }) => {
    return (
      <CustomButton
        width="50"
        height="42px"
        borderRadius="8px"
        textAlign="center"
        border={border ? border : "1px solid #3C169B"}
        color={color}
        background="#F7F7F7"
        onClick={onClick}
        title={title}
      />
    );
  };

  // Define reusable table styles
  const tableStyles = {
    marginTop: "20px",
    borderCollapse: "collapse",
    width: "100%",
  };

  const headerStyles = {
    background: "#1F3A60",
    borderRadius: "8px 8px 0px 0px",
    color: "#FFFFFF",
  };

  const TableComponent = ({ data }) => {
    return (
      <>
        <Table responsive style={tableStyles}>
          <thead style={headerStyles}>
            <tr>
              <th>No.</th>
              <th>ຊື່</th>
              <th>ເວລາ</th>
              <th>ຈາກ</th>
              <th>ຈັດການ</th>
            </tr>
          </thead>
          <tbody>
            {/* {data?.filter((item) => item?.isOpen)?.map((item, index) => ( */}
            {data?.map((item, index) => (
              <tr key={index}>
                <td style={{ paddingTop: "1rem", background: item?.isOpen ? "#6EC207": "#FA4032" }}>{index + 1}</td>
                <td style={{ paddingTop: "1rem" }}>{item?.name || "-"}</td>
                <td style={{ paddingTop: "1rem" }}>
                  {item?.updatedAt
                  ? item?.updatedAt.split("T")[0]: "-"}
                </td>
                <td style={{ paddingTop: "1rem" }}>{item?.updatedBy?.firstName || "-"}</td>
                <td style={{ width: "30%" }}>
                {editUserLoading ? <>!Processing...</> : 
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <NewButton
                      title="ເເກ້"
                      color="#3C169B"
                      onClick={() => setEditModal({modal: true, item})}
                    />
                    &ensp;
                    {!item?.isOpen ? <NewButton
                      title="ເປີດ"
                      color="#6EC207"
                      onClick={() => handleOpenSubmit(item)}
                    /> :
                    <NewButton
                      title="ປີດ"
                      color="#DC2626"
                      onClick={() => handleCloseSubmit(item)}
                    />}
                  </div>
                }
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    );
  };

  if (getUserTypeLoading) return (<>loading...</>);
  return (
    !data ? <p>Data not fount.</p> :
    <>
    {/* Add */}
    <NewButton title="ເພີ່ມປະເພດລູກຄ້າ" color="#6EC207"
      border="1px solid #6EC207"
      onClick={() => {setAddModal(true)}}
    />
    <AddUserType/>

    <TableComponent data={data}/>
    <EditUserType/>
    </>
  );
}
